// Extrait de NursePatientDetail / DoctorPatientDetail (handover bloc F2, B3) — uiSurface fourni par la page.
import api from "@/api";

export default function useProfessionalActionTrace(patientId, uiSurface) {
  const traceProfessionalAction = (payload) => {
    api.post(`/patients/${patientId}/professional-actions`, {
      uiSurface,
      ...payload,
    }).catch(() => {});
  };
  return traceProfessionalAction;
}
